import React from 'react';
import { Button } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useCreateWorkflowMutation } from '../../../../../services/WorkflowService';

interface CreateWorkflowButtonProps {
  onSubmit: () => void;
}

export const CreateWorkflowButton: React.FC<CreateWorkflowButtonProps> = ({ onSubmit }) => {
  const [, { isLoading }] = useCreateWorkflowMutation();

  return (
    <Button
      variant="contained"
      startIcon={<SaveIcon />}
      onClick={onSubmit}
      disabled={isLoading}
      sx={{
        backgroundColor: '#162346',
        '&:hover': { backgroundColor: '#1a2a52' },
        fontWeight: 600,
      }}
    >
      {isLoading ? 'Creating...' : 'Create Workflow'}
    </Button>
  );
};

export default CreateWorkflowButton;
